import { ItfbStorePopupModal, SharedConfig, IFeedbackPopupModal } from '../../types/sharedTypes';
import { DEFAULT_APP_LANGS } from '../../const/langs.const';

import {
  FETCH_CONFIG,
  FetchConfigAction,
  FETCH_LANG_JSON,
  FetchLanguageJSONAction,
  FETCH_CONFIG_SHARED
} from '../actions/shared/fetchConfig';
import { SET_CONFIG_CURRENCY_SYMBOLS, SetConfigCurrencySymbolsAction } from '../actions/settings/currencies';
import {
  SET_CONFIG_LANGUAGES,
  SetConfigLanguagesAction,
  SET_CONFIG_DEFAULT_LANGUAGE,
  SetConfigDefaultLanguageAction
} from '../actions/settings/languages';

export interface ConfigState {
  api: string;
  copyright: string;
  languages: Record<string, string>;
  tfbDisclaimer: string;
  langFile: Record<string, string>;
  enableGoogleAnalytics: boolean;
  defaultLanguage: string;
  defaultSorting: Record<string, string>;
  currency: Record<string, string>;
  customerPortalLink: string;
  tfbStorePopupModal: ItfbStorePopupModal;
  feedbackPopupModal: IFeedbackPopupModal;
  sharedConfig: SharedConfig;
  showAiAssistant: boolean;
}

const initialState: ConfigState = {
  api: '',
  copyright: '',
  languages: DEFAULT_APP_LANGS,
  tfbDisclaimer: '',
  langFile: {},
  enableGoogleAnalytics: false,
  defaultLanguage: 'en',
  defaultSorting: {},
  currency: {},
  sharedConfig: {} as SharedConfig,
  customerPortalLink: '',
  tfbStorePopupModal: {} as ItfbStorePopupModal,
  feedbackPopupModal: {} as IFeedbackPopupModal,
  showAiAssistant: false
};

const configReducer = (
  state: ConfigState = initialState,
  action: FetchConfigAction &
    FetchLanguageJSONAction &
    SetConfigCurrencySymbolsAction &
    SetConfigLanguagesAction &
    SetConfigDefaultLanguageAction
): ConfigState => {
  switch (action.type) {
    case FETCH_CONFIG:
      return {
        ...state,
        api: action.config.api,
        copyright: action.config.copyright,
        languages: action.config.languages || state.languages,
        tfbDisclaimer: action.config.tfbDisclaimer,
        enableGoogleAnalytics: action.config?.enableGoogleAnalytics ?? state.enableGoogleAnalytics,
        defaultLanguage: action.config.defaultLanguage || state.defaultLanguage,
        defaultSorting: action.config.defaultSorting,
        currency: state.currency,
        customerPortalLink: action.config.customerPortalLink,
        tfbStorePopupModal: action.config.tfbStorePopupModal,
        feedbackPopupModal: action.config.feedbackPopupModal,
        showAiAssistant: action.config.showAiAssistant ?? false
      };
    case SET_CONFIG_CURRENCY_SYMBOLS:
      return {
        ...state,
        currency: action.currency
      };
    case SET_CONFIG_LANGUAGES:
      return {
        ...state,
        languages: action.languages
      };
    case SET_CONFIG_DEFAULT_LANGUAGE:
      return {
        ...state,
        defaultLanguage: action.defaultLanguage
      };
    case FETCH_LANG_JSON:
      return {
        ...state,
        langFile: action.langFile
      };
    case FETCH_CONFIG_SHARED:
      return {
        ...state,
        sharedConfig: action.config,
        defaultLanguage: action.config?.DefaultLanguage?.toLowerCase() || state.defaultLanguage
      };
    default:
      return state;
  }
};

export default configReducer;
